import React from "react";
import {
  Form,
  Input,
  message,
  Select,
  Button,
  Space,
  Tag,
  Avatar,
  Row,
  Col,
  Dropdown,
  Modal,
  Upload,
  Tooltip,
  Switch,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import {
  EditFilled,
  PlusOutlined,
  UserOutlined,
  DownOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import creditStore from "../store/CreditStore";
import DistributorStore from "../store/DistributorStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import config from "../config";
import CreditAdd from "./CreditAdd";
import SendInvoice from "./sendInvoice";

class CreditList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.selectDistributor = this.selectDistributor.bind(this);
    this.creditStore = new creditStore(this);
    this.distributorStore = new DistributorStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      customerCompId: "",
      creditType: "",
      sendInvoice: "",
      distributor: "",
      distCompanyId: null,
      distributorType: "",
      status: "",
      company_name: "",
      companyVal_Lab: "",
      emailId: "",
      listUpdated: 0,

      companyId: "",
      editType: "",
      dType: "",
      isadmin: "",

      email: "",

      creditType: "",

      createdBy: "",

      openAccountForm: false,
      companyIdForEdit: "",
      listDataUpdate: false,
      showStatusConfirm: false,
      isActive: false,
      storedUserType: "",
    };

    this.columns = [
      {
        // title: "Account Name",
        title: context.translate("_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_"),
        dataIndex: "companyName",
        width: "15%",
        ellipsis: true,
      },
      {
        title: context.translate("_CREDIT_ADDED_"),
        dataIndex: "creditAdded",
        width: "15%",
        ellipsis: true,
      },
      {
        // title: "Contact Phone",
        title: context.translate("_CREDIT_DEDUCTED_"),
        dataIndex: "creditDeducted",
        width: "15%",
        ellipsis: true,
      },
      {
        // title: "Contact Email",
        title: context.translate("_NO_OF_CREDITS_ISSUED_"),
        dataIndex: "totalcreditIssued",
        width: "15%",
        ellipsis: true,
      },

      {
        // title: "Create Date",
        title: context.translate("_CREDIT_USED_"),
        dataIndex: "totalcreditUsed",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_CREDIT_AVAILABLE_"),
        dataIndex: "totalcreditAvailable",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_RENEWAL_CREDIT_ADDED_"),
        dataIndex: "renewCreditAdded",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_RENEWAL_CREDIT_DEDUCTED_"),
        dataIndex: "renewCreditDeducted",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_RENEWAL_CREDIT_ISSUED_"),
        dataIndex: "renewCreditIssued",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_RENEWAL_CREDIT_USED_"),
        dataIndex: "renewCreditUsed",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_RENEWAL_CREDIT_AVAILABLE_"),
        dataIndex: "renewCreditAvailable",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_CREATION_DATE_"),
        dataIndex: "createdate",
        width: "10%",
        ellipsis: true,
      },
      {
        // title: "Create Date",
        title: context.translate("_INVOICE_"),
        dataIndex: "renewCreditAvailable",
        width: "10%",
        ellipsis: true,
        render: (_, record) => {
          return (
            <>
              {(Number(this.props.getUserData().isadmin) === -1 ||
                Number(this.props.getUserData().isadmin) === 3) && (
                <>
                  <Space>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ editType: "generate" });
                        this.onEdit(record);
                      }}
                      disabled={record.invoice ? true : false}
                    >
                      <Tooltip
                        // title="Delete Account"
                        title={this.context.translate(
                          record.invoice
                            ? "_GENERATED_INVOICE_"
                            : "_GENERATE_INVOICE_"
                        )}
                        placement="bottom"
                        //color={config.tooltipColorDelete}
                      >
                        <span>
                          <i
                            class="bi bi-arrow-right-square"
                            style={{ fontSize: "12px" }}
                          ></i>
                        </span>
                      </Tooltip>
                    </Link>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ editType: "edit" });
                        this.onEdit(record);
                      }}
                      disabled={record.invoice ? false : true}
                    >
                      <Tooltip
                        // title="Delete Account"
                        title={this.context.translate("_EDIT_INVOICE_")}
                        placement="bottom"
                        //color={config.tooltipColorDelete}
                      >
                        <span>
                          {" "}
                          <i
                            class="bi bi-pencil-square"
                            style={{ fontSize: "12px" }}
                          ></i>
                        </span>
                      </Tooltip>
                    </Link>
                  </Space>
                  {/* </Space> */}
                </>
              )}
            </>
          );
        },
      },
      {
        // title: "Action",
        title: context.translate("_DOWNLOAD_"),
        dataIndex: "Action",
        ellipsis: true,
        fixed: "right",
        width: "6%",
        render: (_, record) => {
          return (
            <>
              {(Number(this.props.getUserData().isadmin) === -1 ||
                Number(this.props.getUserData().isadmin) === 3) && (
                <>
                  <Link disabled={record.invoice ? false : true}>
                    <Tooltip
                      title={this.context.translate("_DOWNLOAD_INVOICE_")}
                      placement="top"
                      color={
                        record.status == "1"
                          ? config.activeColor
                          : config.inActiveColor
                      }
                      // onClick={() =>
                      //   this.downloadInvoice(record.invoice)
                      // }
                      onClick={(e) => {
                        window.open(
                          config.fleetURL + "/images/reports/" + record.invoice,
                          "_blank"
                        );
                      }}
                    >
                      <span>
                        <i
                          class="bi bi-arrow-down-circle-fill"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </span>
                    </Tooltip>
                  </Link>
                  {/* </Space> */}
                </>
              )}
            </>
          );
        },
      },
    ];
  }
  closeModal = () => {
    this.setState({ openAccountForm: false, companyIdForEdit: "" });
  };
  closeModal2 = () => {
    this.setState({ sendInvoice: false });
  };
  downloadInvoice = async (record) => {
    this.creditStore.downloadInvoice(record);
  };

  onEdit = async (record) => {
    //console.log(record)
    // await this.context.viewStateStore.setCreditStates({
    //   creditType: record.creditType,
    // });

    await this.setState({ recordId: record.id });
    await this.setState({ sendInvoice: true });
  };

  async componentDidUpdate(prvProp, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const creditStates = this.context.viewStateStore.creditStatesObj;
      console.log(creditStates.creditType);
      console.log(creditStates.companyId);
      if (creditStates.companyId !== "") {
        await this.setState({ distCompanyId: creditStates.companyId });
        await this.setState({ creditType: creditStates.creditType });

        this.handleSearch({
          distCompanyId: creditStates.companyId,
          creditType: creditStates.creditType,
        });
        await this.setState({ loadList: 1, companyLoading: false });
        await this.setState({ loadList: 1 });
      }

      await this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    // console.log(this.props.params?.filter)
    if (this.props.params?.filter?.length > 0) {
      const filter = this.props.params?.filter;
      this.setState({ creditType: filter }, () => {
        this.handleSearch({ distCompanyId: null, creditType: filter });
      });
    }

    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.setState({ companyId: this.props.getUserData().userCompanyId });
    }

    await this.distributorStore.distributorList();
    await this.setState({ listUpdated: 1 }); //need to reload data

    const storedUserType = parseInt(localStorage.getItem("originalUserType"));
    this.setState({ storedUserType: storedUserType });

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    console.log(pagination, "paadsadsfsg");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch({
      distCompanyId: null,
      creditType: null,
    });
  }

  async selectDistributor(value, option) {
    console.log(value);
    await this.creditStore.getDistributorCompanies({ companyId: value });

    await this.setState({
      distCompanyId: value,
      currentPage: 1,
    });
    console.log(this.state.distCompanyId);
    // await this.setState({ distributorType: [{value:value,label:option.createdBy}] });

    await this.handleSearch({
      distCompanyId: value,
      creditType: this.state.creditType,
    });
  }

  async handleSearch({ distCompanyId, creditType }) {
    console.log(creditType);
    this.setState({ loading: true });
    console.log(this.state.distCompanyId);
    await this.creditStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      distCompanyId: distCompanyId ?? this.props.getUserData().userCompanyId,
      creditType: creditType,

      // companyId: 358,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  responseMsg = async (response) => {
    // console.log(resp);
    if (response?.success === "S") {
      message.success(response.message);
      // this.props.navigate("/companylist");
      this.setState({ openAccountForm: false });
      this.setState({ listDataUpdate: true });
    } else {
      if (response.errors[0].companyname) {
        message.error(this.context.translate(response.errors[0]?.companyname));
      }
      if (response.errors[0]?.username) {
        message.error(this.context.translate(response.errors[0]?.username));
      }
      this.setState({ loading: false });
    }
  };

  render() {
    //console.log('in render1')

    return (
      <>
        <div style={{ padding: 0 }}>
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="headerFixed" style={{ height: "50px" }}>
              <Col span={12}>
                {/* <div className="heading">Account List</div> */}
                <div className="heading">
                  {this.context.translate("_CREDIT_LIST_")}
                </div>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Space style={{}}>
                  {/* <AddButton
                link="/useradd"
                title={this.context.translate("_ADD_")}
              /> */}

                  <Space
                    style={{
                      float:
                        this.context.locale.direction == "ltr"
                          ? "right"
                          : "left",
                    }}
                  >
                    {/* <AddButton
                  link="/addaccount"
                  title={this.context.translate("_ADD_")}
                /> */}
                    <Button
                      type="primary"
                      onClick={() => this.props.navigate("/creditdetails")}
                    >
                      <i
                        class="bi bi-credit-card-2-back-fill"
                        style={{ marginRight: "5px" }}
                      ></i>

                      {this.context.translate("_CREDIT_DETAILS_")}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => this.props.navigate("/creditrequestlist")}
                    >
                      <i
                        class="bi bi-credit-card-2-back"
                        style={{ marginRight: "5px" }}
                      ></i>

                      {this.context.translate("_CREDIT_REQUESTED_")}
                    </Button>

                    {this.state.storedUserType == 8 && (
                      <Tooltip
                        placement="left"
                        // title="Add"
                        title={this.context.translate(
                          "_FLEET_DRIVER_DRIVERLIST_ADDBTN_"
                        )}
                        color={config.primaryColor}
                      >
                        <Button
                          className="addButton"
                          icon={<PlusOutlined />}
                          type="primary"
                          onClick={() =>
                            this.setState({
                              openAccountForm: true,
                              companyIdForEdit: "",
                            })
                          }
                        ></Button>
                      </Tooltip>
                    )}

                    {/* <Tooltip
                      //  title="Upload"
                      title={this.context.translate("_UPLOAD_")}
                      color={config.tooltipColorEdit}
                    >
                      <Button
                        type={config.uploadBoxType}
                        onClick={() => this.setState({ showUpload: true })}
                      >
                        <UploadOutlined />
                      </Button>
                    </Tooltip> */}
                  </Space>
                </Space>
              </Col>
            </Row>
          )}
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="listInputRow">
              <Col span={16}>
                <Space>
                  {Number(this.props.getUserData().isadmin) === -1 && (
                    <Select
                      style={{
                        width: 250,
                      }}
                      fieldNames={{ label: "name", value: "companyId" }}
                      value={
                        this.state.distCompanyId
                          ? this.state.distCompanyId
                          : null
                      }
                      // placeholder=" Select Distributor1"
                      placeholder={this.context.translate(
                        "_SELECT_ADMIN_USER_"
                      )}
                      onChange={async (val, option) => {
                        await this.selectDistributor(val, option);
                      }}
                      optionFilterProp="children"
                      options={this.distributorStore?.distributors}
                    />
                  )}

                  {/* {Number(this.props.getUserData().isadmin) === -1 && (
                    <Select
                      style={{
                        width: 180,
                      }}
                      fieldNames={{ label: "name", value: "companyId" }}
                      value={
                        this.state.customerCompId
                          ? this.state.customerCompId
                          : null
                      }
                      placeholder={this.context.translate("_CUSTOMER_COMPANY_")}
                      optionFilterProp="children"
                      onSelect={async (value) => {
                        await this.setState({
                          customerCompId: value,
                          currentPage: 1,
                        });
                        await this.handleSearch(value);
                      }}
                      options={this.creditStore?.distributorsComps}
                    />
                  )} */}

                  <Select
                    style={{
                      width: 150,
                    }}
                    placeholder={this.context.translate("_CREDIT_TYPE_")}
                    value={
                      this.state.creditType !== ""
                        ? this.state.creditType
                        : undefined
                    }
                    optionFilterProp="children"
                    onSelect={async (value) => {
                      await this.setState({
                        creditType: value,
                        currentPage: 1,
                      });
                      await this.handleSearch({
                        distCompanyId: this.state.distCompanyId,
                        creditType: value,
                      });
                      await this.setState({ listUpdated: 1 });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All",
                        // label:this.context.translate("_ALL_")
                      },
                      {
                        value: "New",
                        label: this.context.translate("_NEW_"),
                        // label:this.context.translate("_EXPIRED_")
                      },
                      {
                        value: "Renew",
                        label: this.context.translate("_RENEW_"),
                        // label:this.context.translate("_EXPIRINGSOON_")
                      },
                    ]}
                  />
                </Space>
              </Col>
            </Row>
          )}
          <ListTable
            currentPage={this.state.currentPage}
            total={this.creditStore?.total}
            columns={this.columns}
            dataSource={this.creditStore?.credits}
            pageSize={this.state.pageSize}
            // pagination={{

            //   total:this.creditStore.total || 0

            // }}
            loading={this.creditStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openAccountForm && (
          <Modal
            bodyStyle={{ height: "645px" }}
            className="formShowModal" //  {/* css class */}
            // title="User Details"
            title={this.context.translate("_ADD_CREDIT_")}
            centered
            visible={this.state.openAccountForm}
            footer={null}
            onCancel={() => {
              this.setState({ openAccountForm: false, userId: "" });
            }}
            width={665}
          >
            <div>
              <CreditAdd
                userId={this.state.userId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Modal>
        )}

        {this.state.sendInvoice && (
          <Modal
            maskClosable={false}
            title={this.context.translate("_SEND_INVOICE_")}
            //description="Are you sure to change this status?"
            centered
            visible={this.state.sendInvoice}
            footer={null}
            onCancel={() => {
              this.setState({ sendInvoice: false });
            }}
          >
            <div>
              <SendInvoice
                recordId={this.state.recordId}
                response={this.responseMsg}
                closeModal2={this.closeModal2}
                editType={this.state.editType}
              />
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CreditList.contextType = StoreContext;
export default observer(withRouter(CreditList));
